<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Meningocócica ACWY"
            description="Situação vacinal de pessoas com meningocócica ACWY"
            url="/imunizacao/vacina-idade-certa"
          />
        </div>
      </div>
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'

export default {
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
  metaInfo: {
    title: 'Meningocócica ACWY',
    titleTemplate: null,
  },
  data() {
    return {}
  },
}
</script>

<style></style>
